import React from 'react';
import { UniversalLink } from '@plone/volto/components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { Grid } from 'semantic-ui-react';
import { map, isEmpty } from 'lodash';
import { isInternalURL, flattenToAppURL } from '@plone/volto/helpers';

const View = (props) => {
  const { data, mode } = props;
  const isEditMode = mode === 'edit';

  const resolveHref = (item) => {
    const urlObj = Array.isArray(item.url) ? item.url[0] : item.url;
    const rawUrl = urlObj?.['@id'] || urlObj || '';
    const flatUrl = flattenToAppURL(rawUrl);

    if (urlObj?.['@type'] === 'File' || urlObj?.portal_type === 'File') {
      return `${flatUrl}/@@display-file/file`;
    }

    return flatUrl;
  };

  return (
    <div className='tramListFeatured'>
      {data?.title && (
        <h2 className='tramListFeatured__title'>
          {data.title}
        </h2>
      )}

      {data?.description && <p className="text-center mb-4">{data.description}</p>}

      {!isEmpty(data.links) && (
        <Grid>

          <Grid.Row columns={12} as="ul" className="tramListFeatured__list list-unstyled my-0 pb-0">
            {map(data.links, (item, key) => {
              if (!item) return null;

              const itemHref = resolveHref(item);
              const isInternal = isInternalURL(itemHref);

              const urlObj = Array.isArray(item.url) ? item.url[0] : item.url;
              const isFile = urlObj?.['@type'] === 'File' || urlObj?.portal_type === 'File';

              const openInNewTab = !isEditMode && (!isInternal || isFile);

              return (
                <Grid.Column as="li" key={item['@id'] || key} className='tramList__item mb-4' mobile={12} tablet={6} computer={3}>
                  <UniversalLink 
                    className="tramListFeatured__item"
                    href={isEditMode ? undefined : itemHref}
                    target={openInNewTab ? '_blank' : undefined}
                    rel={openInNewTab ? 'noopener noreferrer' : undefined}
                    onClick={isEditMode ? (e) => e.preventDefault() : null}
                  >
                    {item?.title} <FontAwesomeIcon icon={faArrowRight} className='flex-shrink-0 tramListFeatured__item__icon' />
                  </UniversalLink>
                </Grid.Column>
              );
            })}
          </Grid.Row>
        </Grid>
      )}
    </div>
  );
};

export default View;